export type EstadoItem = 'espera' | 'preparar' | 'despachado' | 'agotado';
export type EstadoPedido = 'espera' | 'preparacion';
export type CocinaTab = 'listado' | 'despachados' | 'agotados';
export type CocinaSidebarView = 'por-mesa' | 'por-estados' | 'por-cliente' | 'por-pedidos';

/** Area del KDS. Vacio = todas las estaciones. */
export interface CocinaArea {
  valor: string;
  etiqueta: string;
}

export const COCINA_AREAS: CocinaArea[] = [
  { valor: '', etiqueta: 'Todas' },
  { valor: 'COCINA', etiqueta: 'Cocina' },
  { valor: 'BAR', etiqueta: 'Bar' },
  { valor: 'TIENDA', etiqueta: 'Tienda' },
];

export interface Complemento {
  nombre: string;
  cantidad: number;
}

export interface CocinaItem {
  /** order_item_id de ventas: es el id que se usa para cambiar el estado. */
  id: string;
  productoId: string;
  nombre: string;
  cantidad: number;
  complementos: Complemento[];
  notas: string | null;
  estado: EstadoItem;
  paraLlevar: boolean;
  retrasado: boolean;
}

export interface CocinaPedido {
  /** ticket_id de la comanda. */
  id: string;
  ordenId: string;
  ordenNumero: string | null;
  estacion: string;
  mesaNumero: string | null;
  esHabitacion: boolean;
  meseroNombre: string | null;
  clienteNombre: string | null;
  estado: EstadoPedido;
  /** Momento del pedido segun el reloj del navegador (para el cronometro). */
  inicioMs: number;
  items: CocinaItem[];
}

export interface CambioEstadoItem {
  itemId: string;
  estado: EstadoItem;
}

export interface CocinaItemDespachado {
  id: string;
  mesa: string;
  mesero: string;
  pedido: string;
  cantidad: number;
  horaPedido: string;
  horaDespacho: string;
  tiempoEspera: string;
  notas: string;
}

/** Insumo sin stock disponible; el dato es de inventario y cocina solo lo muestra. */
export interface CocinaInsumoAgotado {
  id: number;
  insumo: string;
  sku: string;
  tipo: string;
  categoria: string;
  disponible: number;
}

export interface ResumenProducto {
  productoId: string;
  nombre: string;
  cantidad: number;
}

export interface Pagina<T> {
  items: T[];
  pagina: number;
  tamano: number;
  total: number;
  totalPaginas: number;
}

export function paginaVacia<T>(tamano: number): Pagina<T> {
  return { items: [], pagina: 0, tamano, total: 0, totalPaginas: 0 };
}

/** Titulo de la tarjeta: mesa/habitacion, o cliente en las vistas por cliente. */
export function etiquetaPedido(pedido: CocinaPedido, vistaCliente: boolean): string {
  if (vistaCliente && pedido.clienteNombre) {
    return pedido.clienteNombre;
  }
  if (pedido.mesaNumero) {
    return `${pedido.esHabitacion ? 'Habitación' : 'Mesa'}: ${pedido.mesaNumero}`;
  }
  return pedido.ordenNumero ? `Pedido ${pedido.ordenNumero}` : 'Pedido';
}

export function segundosDesde(inicioMs: number, ahoraMs: number): number {
  return Math.max(0, Math.floor((ahoraMs - inicioMs) / 1000));
}

/** 75 -> "01:15"; con una hora o mas -> "1:02:05". */
export function formatearDuracion(segundos: number | null | undefined): string {
  if (segundos === null || segundos === undefined) {
    return '-';
  }
  const horas = Math.floor(segundos / 3600);
  const minutos = Math.floor((segundos % 3600) / 60);
  const segs = segundos % 60;
  const mm = String(minutos).padStart(2, '0');
  const ss = String(segs).padStart(2, '0');
  return horas > 0 ? `${horas}:${mm}:${ss}` : `${mm}:${ss}`;
}
